<div class="modal-backdrop" [@modalFadeIn]>
  <div class="modal-container">
    <div class="modal">
      <!-- Modal Header -->
      <div class="modal-header">
        <h3 class="modal-title">{{ data.plan.name }}</h3>
        <div class="header-actions">
          <button mat-icon-button [matMenuTriggerFor]="modalMenu" aria-label="Mais ações">
            <mat-icon>more_vert</mat-icon>
          </button>
          <button mat-icon-button mat-dialog-close aria-label="Fechar modal">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <mat-menu #modalMenu="matMenu">
        <button mat-menu-item (click)="viewPayments()">
          <mat-icon>receipt_long</mat-icon>
          <span>Ver Pagamentos</span>
        </button>
        <button mat-menu-item (click)="openUpgradeModal()" *ngIf="canUpgrade()">
          <mat-icon>upgrade</mat-icon>
          <span>Fazer Upgrade</span>
        </button>
        <ng-container *ngIf="data.plan.active">
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="toggleAutoRenew()" [disabled]="isUpdatingAutoRenew()">
            <mat-icon>{{ isUpdatingAutoRenew() ? 'hourglass_empty' : 'autorenew' }}</mat-icon>
            <span>{{ isUpdatingAutoRenew() ? 'Atualizando...' : (data.plan.autoRenew ? 'Desativar Renovação Auto.' :
              'Ativar Renovação Auto.') }}</span>
          </button>
        </ng-container>
      </mat-menu>

      <mat-dialog-content class="modal-body">
        <!-- General Info Section -->
        <section class="info-section">
          <h3>Informações Gerais</h3>
          <div class="info-grid">
            <div class="info-item">
              <strong>ID:</strong>
              <span>{{ data.plan.id }}</span>
            </div>
            <div class="info-item">
              <strong>CPF/CNPJ:</strong>
              <span>{{ (data.plan.cpfcnpj || '') | cpfMask }}</span>
            </div>
            <div class="info-item">
              <strong>Status:</strong>
              <mat-chip [color]="data.plan.active ? 'accent' : 'warn'">
                {{ data.plan.active ? 'Ativo' : 'Inativo' }}
              </mat-chip>
            </div>
            <div class="info-item">
              <strong>Criado em:</strong>
              <span>{{ data.plan.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="info-item">
              <strong>Atualizado em:</strong>
              <span>{{ data.plan.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="info-item">
              <strong>Renovação Automática:</strong>
              <span class="auto-renew-badge" [class.active]="data.plan.autoRenew">
                <mat-icon>{{ data.plan.autoRenew ? 'autorenew' : 'block' }}</mat-icon>
                {{ data.plan.autoRenew ? 'Ativada' : 'Desativada' }}
              </span>
            </div>
          </div>
        </section>

        <mat-divider></mat-divider>

        <!-- Financial Summary Section -->
        <section class="financial-section">
          <h3>Resumo Financeiro</h3>
          <div class="financial-cards">
            <mat-card class="financial-card">
              <mat-card-content>
                <span class="label">Valor Bruto</span>
                <span class="value">{{ data.plan.grossTotal | currency:'BRL' }}</span>
              </mat-card-content>
            </mat-card>
            <mat-card class="financial-card discount">
              <mat-card-content>
                <span class="label">Descontos</span>
                <span class="value">-{{ data.plan.totalDiscounts | currency:'BRL' }}</span>
              </mat-card-content>
            </mat-card>
            <mat-card class="financial-card total">
              <mat-card-content>
                <span class="label">Valor Líquido</span>
                <span class="value">{{ data.plan.finalTotal | currency:'BRL' }}</span>
              </mat-card-content>
            </mat-card>
          </div>
        </section>

        <mat-divider></mat-divider>

        <!-- Items Table Section -->
        <section class="items-section">
          <h3>Itens do Plano ({{ data.plan.items?.length || 0 }})</h3>
          <div class="table-container">
            <table mat-table [dataSource]="data.plan.items || []" class="items-table">
              <!-- Product Column -->
              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>Produto</th>
                <td mat-cell *matCellDef="let item">{{ item.product?.name || 'N/A' }}</td>
              </ng-container>

              <!-- Quantity Column -->
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
              </ng-container>

              <!-- Unit Price Column -->
              <ng-container matColumnDef="unitPrice">
                <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
                <td mat-cell *matCellDef="let item">{{ item.unitPrice | currency:'BRL' }}</td>
              </ng-container>

              <!-- Total Column -->
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>Total</th>
                <td mat-cell *matCellDef="let item">
                  {{ getItemTotal(item.quantity, item.unitPrice) | currency:'BRL' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <!-- Empty state for items -->
          <div class="empty-state" *ngIf="!data.plan.items || data.plan.items.length === 0">
            <mat-icon>inventory_2</mat-icon>
            <p>Nenhum item cadastrado neste plano</p>
          </div>
        </section>

        <!-- Botão para adicionar pagador externo (quando não há pagador e plano ativo) -->
        <ng-container *ngIf="!hasExternalPayer() && data.plan.active">
          <mat-divider></mat-divider>
          <section class="info-section payer-section">
            <div class="section-header">
              <h3>Pagador Externo</h3>
            </div>

            <!-- Estado: sem pagador e não editando -->
            <div class="payer-empty" *ngIf="!isEditingPayer()">
              <mat-icon>account_circle</mat-icon>
              <span>Nenhum pagador externo vinculado. O próprio titular é responsável pelo pagamento.</span>
              <button mat-stroked-button class="btn-sm" (click)="startEditPayer()" style="margin-top: 12px;">
                <mat-icon>person_add</mat-icon>
                Adicionar Pagador Externo
              </button>
            </div>

            <!-- Estado: editando / definindo payerCnpj -->
            <div class="payer-edit-form" *ngIf="isEditingPayer()">
              <mat-form-field appearance="outline" class="payer-input">
                <mat-label>CPF ou CNPJ do Pagador</mat-label>
                <mat-icon matPrefix>badge</mat-icon>
                <input matInput [ngModel]="payerCnpjInput()" (ngModelChange)="payerCnpjInput.set($event)"
                  mask="000.000.000-00||00.000.000/0000-00" [dropSpecialCharacters]="true"
                  placeholder="Ex: 00.000.000/0000-00">
                <mat-hint>Informe o CNPJ da pessoa/empresa responsável pelo pagamento</mat-hint>
              </mat-form-field>
              <div class="payer-edit-actions">
                <button mat-button (click)="cancelEditPayer()" [disabled]="isSavingPayer()">Cancelar</button>
                <button mat-flat-button color="primary" (click)="savePayer()"
                  [disabled]="!payerCnpjInput().trim() || isSavingPayer()">
                  <mat-spinner *ngIf="isSavingPayer()" diameter="16" style="margin-right:6px"></mat-spinner>
                  <mat-icon *ngIf="!isSavingPayer()">save</mat-icon>
                  {{ isSavingPayer() ? 'Salvando...' : 'Salvar' }}
                </button>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- Seção de pagador externo (apenas quando há pagador vinculado) -->
        <ng-container *ngIf="hasExternalPayer()">
          <mat-divider></mat-divider>
          <section class="info-section payer-section">
            <div class="section-header">
              <h3>Pagador Externo</h3>
              <div class="section-actions" *ngIf="!isEditingPayer()">
                <button mat-icon-button matTooltip="Alterar pagador" (click)="startEditPayer()">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Remover pagador" color="warn" (click)="removePayer()">
                  <mat-icon>person_remove</mat-icon>
                </button>
              </div>
            </div>

            <!-- Estado: editando / definindo payerCnpj -->
            <div class="payer-edit-form" *ngIf="isEditingPayer()">
              <mat-form-field appearance="outline" class="payer-input">
                <mat-label>CPF ou CNPJ do Pagador</mat-label>
                <mat-icon matPrefix>badge</mat-icon>
                <input matInput [ngModel]="payerCnpjInput()" (ngModelChange)="payerCnpjInput.set($event)"
                  mask="000.000.000-00||00.000.000/0000-00" [dropSpecialCharacters]="true"
                  placeholder="Ex: 00.000.000/0000-00">
                <mat-hint>Informe o CPF ou CNPJ da pessoa/empresa responsável pelo pagamento</mat-hint>
              </mat-form-field>
              <div class="payer-edit-actions">
                <button mat-button (click)="cancelEditPayer()" [disabled]="isSavingPayer()">Cancelar</button>
                <button mat-flat-button color="primary" (click)="savePayer()"
                  [disabled]="!payerCnpjInput().trim() || isSavingPayer()">
                  <mat-spinner *ngIf="isSavingPayer()" diameter="16" style="margin-right:6px"></mat-spinner>
                  <mat-icon *ngIf="!isSavingPayer()">save</mat-icon>
                  {{ isSavingPayer() ? 'Salvando...' : 'Salvar' }}
                </button>
                <button *ngIf="canRequestPayment()" mat-flat-button color="primary" (click)="requestPayment()"
                  [disabled]="isRequestingPayment()">
                  <mat-spinner *ngIf="isRequestingPayment()" diameter="18" style="margin-right:6px"></mat-spinner>
                  <mat-icon *ngIf="!isRequestingPayment()">send</mat-icon>
                  {{ isRequestingPayment() ? 'Solicitando...' : 'Solicitar Cobrança' }}
                </button>
              </div>
            </div>

            <!-- Estado: pagador vinculado, exibindo status -->
            <ng-container *ngIf="!isEditingPayer()">
              <div class="payer-info-row">
                <mat-icon class="payer-icon">business</mat-icon>
                <div class="payer-details">
                  <span class="payer-label">CPF/CNPJ do Pagador</span>
                  <strong class="payer-value">{{ data.plan.payerCnpj! | cpfMask }}</strong>
                </div>
                <mat-chip [class]="data.plan.payerAccepted ? 'chip-success' : 'chip-warning'">
                  {{ data.plan.payerAccepted ? 'Aceito' : 'Aguardando' }}
                </mat-chip>
              </div>

              <!-- Aguardando aceitação -->
              <div class="alert alert-warning alert-inline" *ngIf="!data.plan.payerAccepted">
                <mat-icon>hourglass_top</mat-icon>
                <span>Aguardando o pagador aceitar a responsabilidade de pagamento.</span>
              </div>

              <!-- Aceito, cobrança ainda não solicitada -->
              <div class="alert alert-info alert-inline" *ngIf="canRequestPayment()">
                <mat-icon>info_outline</mat-icon>
                <span>Pagador aceitou a responsabilidade. Solicite a cobrança quando estiver pronto.</span>
              </div>

              <!-- Cobrança já solicitada -->
              <div class="alert alert-success alert-inline" *ngIf="paymentAlreadyRequested()">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Cobrança solicitada em <strong>{{ data.plan.paymentRequestedAt | date:'dd/MM/yyyy HH:mm'
                    }}</strong>. Aguardando confirmação do pagador.</span>
              </div>
            </ng-container>
          </section>
        </ng-container>

        <!-- Discounts Section -->
        <section class="discounts-section" *ngIf="data.plan.discounts && data.plan.discounts.length > 0">
          <mat-divider></mat-divider>
          <h3>Descontos Aplicados ({{ data.plan.discounts.length }})</h3>
          <div class="discounts-list">
            <mat-card *ngFor="let discount of data.plan.discounts" class="discount-card">
              <mat-card-content>
                <div class="discount-header">
                  <strong>{{ discount.description }}</strong>
                  <mat-chip color="accent">{{ getDiscountType(discount) }}</mat-chip>
                </div>
                <div class="discount-value">
                  {{ getDiscountValue(discount) }}
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </section>
      </mat-dialog-content>

      <!-- Modal Actions -->
      <mat-dialog-actions class="modal-footer">
        <button mat-button (click)="close()">Fechar</button>
        <button *ngIf="canUpgrade()" mat-stroked-button color="primary" (click)="openUpgradeModal()">
          <mat-icon>upgrade</mat-icon>
          Fazer Upgrade
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>